import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonText, IonModal } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

function addStorage_cart(event) {

    Preferences.set({
        key: 'cartList',
        value: JSON.stringify(event),
        //value: [event[0], event[1], event[2], event[3],  event[4]].toString(),

    })
}

export function Helpdesk_Public (props) {


    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authMerchant_objects.acctID);
    let [employeeID, setEmployeeID ] = useState(authMerchant_objects.employeeID);
    let [schema, setSchema ] = useState(authMerchant_objects.schema);
    let [access, setAccessRights ] = useState(authMerchant_objects.accessRights);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);
    let [wss, setWebsocket ] = useState(authMerchant_objects.websocket);

    // Sample clients with messages
    const [clients, setClients] = useState({});

    let [chatID, setChatID] = useState(null);

    let [messageSent, setMessageSent] = useState(false);
    let [viewMessages, setMessages] = useState([]);
    let [inputMessage, setInputMessage] = useState('');


  function getMessages() {

    setMessages([]);

    const requestOptions = {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74706_helpDesk_public_getMessages',
            user: acctID,
            sessionID: sessionID,
        }),
    }

    
    fetch(baseURL+'ghanaverified/', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        const updatedMessages = [];

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {

        let cols = rows[rownum].split('|');

        setChatID(cols[0])

        const chain = JSON.parse(cols[3]);


            for (let colRow = 0; colRow < Object.keys(chain).length; ++colRow) {

                updatedMessages.push({
                    id: chain[colRow].id,
                    text: chain[colRow].text,
                    sender: chain[colRow].sender,
                });
            }
        }

        setMessages(prev => prev.concat(updatedMessages));
        
    })

}


  function sendMessage()
  {  

            const requestOptions = {
              method: 'POST',
              //mode: 'no-cors',
              credentials: 'include',
              headers: {
                  'Accept': 'text/html, application/json',
                  'content-type': 'application/json',
                  //'cookie': 'cookie',
              },
              body: JSON.stringify({
                  Tracker: '74706_helpDesk_public_sendMessages',
                  user: acctID,
                  xChatID: chatID,
                  xHelp_chat_message: JSON.stringify(viewMessages),
                  sessionID: sessionID,
  
              }),
          }
  
  
          let newBaseURL = 'https://ghanaverified.com';
          if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
          {
              newBaseURL = 'https://ghanaverifiedtest.com'
          }
  
          fetch(baseURL+'ghanaverified/', requestOptions)
          .then(res => res.text())
          .then(res => {
              
                getMessages();

        })
          
  
  }

  function sendMessageHandler()
  {


        let updatedClientList = {};

        setMessages((prevMessages) => {

            const nextID = prevMessages.length + 1;

            const clientItem = {
                id: nextID,
                text: inputMessage,
                sender: acctID,
            };
        
            const updatedMessages = [...prevMessages, clientItem];
        
            addStorage_cart(updatedMessages);
            setMessageSent(true);
        
            return updatedMessages;
        });

        //sendMessage();

        authMerchant_objects.changeCartList((prevClientList) => {

            let nextID = Object.keys(prevClientList).length + 1;

            let clientItems = {
                id: nextID,
                text: inputMessage,
                sender: acctID,
                };

            return {
                ...prevClientList,
                [nextID]: clientItems // Add new client item using `acctID` as the key
            };
        });

  }

  function inputMessageHandler(event)
  {

    setInputMessage(event);
  }


  useEffect(() => {

    wss.onmessage = (event) => {

      const data = JSON.parse(event.data);


      if (data.type === 'CHAT_UPDATED') 
      {
        getMessages();
      }
    };


    wss.onerror = (error) => {
        //alert("WebSocket error: " +error);
    };


  }, []);




  useEffect(() => {
    if (messageSent) {
        sendMessage();
        setMessageSent(false); // Reset flag to prevent repeated calls
    }
}, [messageSent]);


useEffect(() =>  {

    getMessages(); 

}, [])

  return (
    <React.Fragment>

          {/* Chat Modal */}
          {props.openModal == true ?
            (
        <IonModal isOpen={props.openModal}>
            <IonHeader style={{ color: "black" }}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='9'>
                            <h4>HELP DESK</h4>
                        </IonCol>
                        <IonCol size='3'>
                            <IonButton onClick={() => props.closeModal()}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>

            <IonContent className='grid_content'>
                <IonGrid>
                    {viewMessages.map((detailData) =>   {
                    return (
                            <IonRow>
                                {detailData.sender == acctID && <IonCol size='12' style={{ fontSize: "16px", textAlign: "left"}} >
                                    <IonText >{detailData.text} </IonText>
                                </IonCol>}
                                {detailData.sender != acctID && <IonCol size='12' style={{ fontSize: "16px", textAlign: "right"}} >
                                    <IonText >{detailData.text} </IonText>
                                </IonCol>}
                            </IonRow>
                            )
                        }
                    )}
                </IonGrid>
            </IonContent>

            <IonFooter className='grid_footer'>
                <IonGrid style={{ color: "black" }}>
                    <IonRow>
                        <IonCol size="9">
                            <IonInput type='text' placeholder="Type a message..." value={inputMessage }  autocomplete='off' onIonChange={(e) => inputMessageHandler(e.target.value)} ></IonInput>
                        </IonCol>
                        <IonCol size='3'>
                            <IonButton onClick={() => sendMessageHandler()}>Send</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
          </IonModal>
        ): null }

    </React.Fragment>
  );
};

export default Helpdesk_Public;